export default {
  name: 'analytic',
  config: {
    baseURL: `${process.env.VUE_APP_API_BASE_URL}/calculations`
    // baseURL:
    // 'https://sls-cus-dev-api-core-app.azurewebsites.net/api/calculations'
  }
};
